export default "__VITE_ASSET__vfl4fIP6__"